/**
 * Sidebar tab display names — single source of truth for role checks (`canSeeTab`) and labels.
 */
export const SIDEBAR_TABS = {
  DASHBOARD: "Dashboard",
  USERS: "Users",
  SUBSCRIPTION: "Subscription",
  MANUAL_PURCHASE: "Manual Purchase",
  NOTIFICATIONS: "Notifications",
  PROMOTIONAL_MESSAGES: "Promotional Messages",
  ADS: "Ads",
  BLOG: "Blog",
  USER_PROFILES: "User Profiles",
  CONTENT_REPORTS: "Content Reports",
  BANNED_USERS: "Banned Users",
  MATCH_USER: "Match User",
  APP_VERSION_CONTROL: "App Version Control",
  ADMIN_PANEL_USERS: "Admin Panel Users",
  BOOST_HISTORY: "Boost History",
  DUMMY_USERS: "Dummy Users",
};
